export const SPREADSHEET_TEMPLATE_LINKS = {
  historicalBooks: {
    journalEntries: "https://docs.google.com/spreadsheets/d/1pmzYnEVJnHANPDxhlBSx_bvTUlKSWduS/copy",
    coaUpload: "https://docs.google.com/spreadsheets/d/11R4bsf-AzpghvlZinMJ0Y1DQrPdEOdYG/copy",
  },
  importBills:
    "https://docs.google.com/spreadsheets/d/1fqjv8rUUpXXiOppl47OK2byNQZ79O7k2B3lmaawcbjw/copy",
  modelProfitAndLoss:
    "https://docs.google.com/spreadsheets/d/147IBpva8Dyrx8lVcgpGv1sfGEI-4HRHT5M7Dg9XNFe8/copy",
  modelBudget:
    "https://docs.google.com/spreadsheets/d/1NImoIMBBKCRuNf-qaDspp_Fw6xaqTJJvIw9XA8OYqy0/copy",
};
